<template lang="pug">
  #DeliveryStateCards
    b-row(cols="1" cols-md="5")
      b-col.mb-2
        state-count-card(
          stateName="Total solicitudes"
          color="var(--status-in-transit)"
          icon="pending_actions"
          :stateCount="statusCounters['TOTAL']"
        )
      b-col.mb-2
        state-count-card(
          :stateName="ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.PENDING]"
          color="var(--status-partial)"
          icon="pending_actions"
          :stateCount="statusCounters[ASSIGNMENT_ITEM_STATUS.PENDING]"
        )
      b-col.mb-2
        state-count-card(
          :stateName="ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.ACCEPTED]"
          color="var(--status-approved)"
          icon="check_circle"
          :stateCount="statusCounters[ASSIGNMENT_ITEM_STATUS.ACCEPTED]"
        )
      b-col.mb-2
        state-count-card(
          :stateName="ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.REJECTED]"
          color="var(--status-rejected)"
          icon="cancel"
          :stateCount="statusCounters[ASSIGNMENT_ITEM_STATUS.REJECTED]"
        )
</template>

<script>
import StateCountCard from '../UI/StateCountCard'
import { mapGetters } from 'vuex'
import { ASSIGNMENT_ITEM_STATUS, ASSIGNMENT_ITEM_STATUS_TEXT } from '@/constants/assignmentItemStatus'

export default {
  components: {
    StateCountCard
  },
  data() {
    return {
      ASSIGNMENT_ITEM_STATUS,
      ASSIGNMENT_ITEM_STATUS_TEXT
    }
  },
  computed: {
    ...mapGetters('assignment', ['statusCounters'])
  }
}
</script>
